export const TECHNICAL_SUPPORT = 'Technical support';
